/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_GETVIDEOTAG,GETVIDEOTAG_RECEIVED } = constants.GetVideoTagConstant;

export default {
    REQUEST_GETVIDEOTAG,
    GETVIDEOTAG_RECEIVED,

  requestAddVideoTag: payload => ({
    type: REQUEST_GETVIDEOTAG,
    payload
  }),
  AddVideoTagReceived: () => ({
    type: GETVIDEOTAG_RECEIVED
  }),
};
